<template lang="pug">
  .max-w-320.mx-auto.mx-lg-0
    h4.mb-2 Welcome!
    p.mb-5 {{ message }}
    .alert.alert-danger(v-if="hasError")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  {{ errorMessage }}

    el-form(
      :model="signIn"
      status-icon
      :rules="rules"
      ref="signIn"
      @submit.native.prevent="validateForm('signIn')"
    )
      el-form-item(prop="username").mb-4
        el-input(
          v-model="signIn.username"
          type="email"
          placeholder="Email"
          auto-complete="off"
          @blur="validateEmail"
        )

      el-form-item(prop="password").mb-4
        el-input(v-model="signIn.password" type="password" placeholder="Password")

      el-form-item
        el-button(
          type="primary",
          native-type="submit"
          v-loading.fullscreen.lock="loading"
        ).w-100 Sign In
      router-link(to="/sign-up").d-block Sign Up
      router-link(to="/forgot-password").d-block Forgot your password?
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue';
import authMixin from './AuthMixin';

export default {
  name: 'SignIn',
  mixins: [authMixin],
  data() {
    return {
      message: 'Please login to your account',
      signIn: {
        username: '',
        password: '',
      },

      hasError: false,
      errorMessage: '',
      loading: false,
      userToReset: {},

      rules: {
        username: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],
        password: { required: true, message: 'Please enter your password', trigger: 'blur' },
      },
    };
  },

  mounted() {
    if (this.$route.query.from && this.$route.query.from === 'signUp') {
      this.message = 'A Verification Email has been sent to you to set your password '
        + 'and enable your account. Please check your email Inbox. '
        + 'If you don\'t see an email, please also check Spam or Junk folders';
    }
  },

  methods: {
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.cognitoSignIn();
        }
        return false;
      });
    },

    validateEmail() {
      // !!valid returns true/false;
      this.$refs.signIn.validateField('email', (valid) => !!valid);
    },

    cognitoSignIn() {
      this.loading = true;
      this.error = false;
      this.$Amplify.Auth.signIn(this.signIn.username, this.signIn.password)
        .then((data) => {
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            console.log('Not Handled');
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.$router.push('/change-password');
            this.userToReset = data;
          } else if (data.challengeName === 'MFA_SETUP') {
            console.log('Not Handled');
          } else if (data.challengeName === 'CUSTOM_CHALLENGE'
            && data.challengeParam
            && data.challengeParam.trigger === 'true'
          ) {
            console.log('Not Handled');
          } else {
            if (data.attributes['custom:signup'] === 'init') {
              console.log('redirecting to sync');
              this.$router.push('/sync');
              return;
            }
            AmplifyEventBus.$emit('authState', 'signedIn');
          }
        }).catch((err) => {
          console.log(err);
          this.hasError = true;
          this.errorMessage = 'Username or Password incorrect.';
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
